import React from 'react'
import Herosection from './Components/Herosection'
import Feature from './Components/Feature'
import AboutSection from './Components/AboutSection'
import ProjectSection from './Components/ProjectSection'
import Counter from './Components/Counter'
import Techarea from './Components/Techarea'
import './Home.css'
import Services from './Components/Services'
import Solve from './Components/Solvearea'
import BlogArea from './Components/blogarea'

const Home = () => {
  return (
    <div>
        <Herosection/>
        <Feature/>
        <AboutSection/>
        {/* <ProjectSection/> */}
        <Counter/>
        <Techarea/>
        {/* <Services/> */}
        <Solve/>
        {/* <BlogArea/> */}
    </div>
  )
}

export default Home